/**
 * Adapta el `query` que genera el mixin de tablas al contrato del endpoint de
 * logs del balanceador (`/shipment.balancing.api/client-groups/{uuid}/logs/pagination`).
 *
 * El endpoint es mas estricto que el resto de la API:
 *  - exige `alias: "sbl"` en cada clausula del `where`;
 *  - solo acepta los operadores `equal`, `between` y `like`;
 *  - solo acepta como filtrables los campos de `FILTERABLE_FIELDS`;
 *  - no documenta ordenacion, asi que el `order` no se envia.
 */

export const BALANCER_LOGS_ALIAS = "sbl";

const BETWEEN_FIELDS = ["created_at"];
const EQUAL_FIELDS = [
    "client_id",
    "input_campaign_id",
    "enqueue_source",
    "outcome",
    "event",
    "lead_id",
];
const LIKE_FIELDS = ["message"];

export const FILTERABLE_FIELDS = [
    ...BETWEEN_FIELDS,
    ...EQUAL_FIELDS,
    ...LIKE_FIELDS,
];

function stripWildcards(value) {
    return `${value}`.replace(/^%+|%+$/g, "");
}

/**
 * Devuelve la clausula normalizada al operador que soporta el campo, o `null`
 * si no hay nada que el endpoint pueda entender.
 */
function normalizeClause(field, clause) {
    if (!clause || typeof clause !== "object") {
        return null;
    }

    if (BETWEEN_FIELDS.includes(field)) {
        // El mixin añade un tercer elemento (`false`) que el contrato no espera.
        return Array.isArray(clause.between)
            ? { between: clause.between.slice(0, 2) }
            : null;
    }

    if (EQUAL_FIELDS.includes(field)) {
        if ("equal" in clause) {
            return { equal: clause.equal };
        }
        // Los filtros de columna siempre generan un `like` con comodines.
        if ("like" in clause) {
            return { equal: stripWildcards(clause.like) };
        }
        return null;
    }

    if (LIKE_FIELDS.includes(field)) {
        return "like" in clause ? { like: clause.like } : null;
    }

    return null;
}

export function adapterBalancerLogsQuery(query = {}) {
    const where = {};

    for (const field in (query && query.where) || {}) {
        const clause = normalizeClause(field, query.where[field]);
        if (clause) {
            where[field] = {
                ...clause,
                alias: BALANCER_LOGS_ALIAS,
            };
        }
    }

    return Object.keys(where).length > 0 ? { where } : {};
}
